import { BaseEvent } from "@fideus/analytics";

interface ConnectionProblemData {
  /** The error message from the failed request */
  errorMessage: string;
  /** Number of retry attempts made before giving up (0 if tracking during retry) */
  retryCount: number;
  /** Whether this was the final failure or an intermediate retry */
  isFinalFailure: boolean;
  /** The URL that was being fetched, if available */
  url?: string;
}

export class ConnectionProblemEvent extends BaseEvent<ConnectionProblemData> {
  override readonly "detail-type" = "Connection Problem" as const;
}
